
export const getVideo = async (id) => {

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

    try {
      const response = await fetch(`${apiUrl}/videos/foundation/foundation/video/${id}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (response.status === 200) {
        const expiration = Date.now() + 60 * 60 * 1000; // 1 hour from now
        return { videoUrl: data.videoUrl, expirationTime: expiration, status: response.status };
      } else if (response.status === 401) {
        // remove local storage items related to session
        localStorage.removeItem('session_active');
        localStorage.removeItem('username');
        localStorage.removeItem('contributorType');
        return { videoUrl: null, expirationTime: null, status: response.status, message: data.message };
      } else if (response.status === 402 || response.status === 403 || response.status === 404 || response.status === 409 || response.status === 500) {
        return { videoUrl: null, expirationTime: null, status: response.status, message: data.message };
      } else {
        console.error('Error fetching video URL:', data.message);
        return null;
      }
    } catch (error) {
      console.error('Error fetching video URL:', error);
    }
};